
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AutoSizeTextarea from '@/ui/AutoSizeTextarea.vue';
import { TextConfiguration } from '@/ui/BookBuilder.vue';

@Component({
    components: { AutoSizeTextarea },
})
export default class LargeTextCell extends Vue {
    @Prop({ type: Number, required: true })
    public readonly pageIndex!: number;

    @Prop({ type: Boolean, required: false, default: false })
    public readonly limitHeight!: boolean;

    @Prop({ type: Object, required: false, default: null })
    public readonly value!: TextConfiguration | null;

    public text: string = '';
    public centered: boolean = false;
    public editing = false;

    @Watch('value', { immediate: true })
    public onValueChanged(value: TextConfiguration | null): void {
        const newText = value?.text || '';
        const newCentered = value?.centered || false;
        if (this.text !== newText) {
            this.text = newText;
        }
        if (this.centered !== newCentered) {
            this.centered = newCentered;
        }
    }

    @Watch('text')
    public onTextChanged(text: string): void {
        this.$emit('input', { text, centered: this.centered });
    }

    @Watch('centered')
    public onCenteredChanged(centered: boolean): void {
        this.$emit('input', { text: this.text, centered });
    }
}
